export function AppFooter() {
  return (
    <footer className="mt-12 border-t border-border/60 py-6 text-center text-xs text-muted-foreground">
      <p>🎬 lowbass' TV Tracker · Created by Joshua 'lowbass' Sommerfeldt</p>
      <p className="mt-1 opacity-70">Track your shows across Netflix, HBO, theaters &amp; more 🍿</p>
    </footer>
  )
}
